import { useState, type FormEvent } from 'react';
import type { MilestonePayload } from '../api/types.js';
import { Button } from './Button.js';
import { MILESTONE_KIND_LABELS } from '../lib/labels.js';

const KINDS = Object.keys(MILESTONE_KIND_LABELS) as MilestonePayload['kind'][];

/**
 * 里程碑录入表单（organizer 用，EventDetail 页内嵌）。
 * dueAt 用原生 date 输入（YYYY-MM-DD），提交时原样传给后端（后端 parseDueDate 归一化）。
 */
export function MilestoneForm({
  onSubmit,
  submitting = false,
}: {
  onSubmit: (payload: MilestonePayload) => void;
  submitting?: boolean;
}) {
  const [kind, setKind] = useState<MilestonePayload['kind']>('register_close');
  const [label, setLabel] = useState('');
  const [dueAt, setDueAt] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const trimmed = label.trim();
    if (trimmed === '' || dueAt === '') return;
    onSubmit({ kind, label: trimmed, dueAt });
    setLabel('');
    setDueAt('');
  };

  return (
    <form className="row" onSubmit={handleSubmit} aria-label="新增里程碑表单">
      <div className="field" style={{ maxWidth: '150px' }}>
        <label className="field-label" htmlFor="milestone-kind">
          类型
        </label>
        <select
          id="milestone-kind"
          className="select"
          value={kind}
          onChange={(event) => setKind(event.target.value as MilestonePayload['kind'])}
        >
          {KINDS.map((value) => (
            <option key={value} value={value}>
              {MILESTONE_KIND_LABELS[value]}
            </option>
          ))}
        </select>
      </div>
      <div className="field grow">
        <label className="field-label" htmlFor="milestone-label">
          里程碑名称
        </label>
        <input
          id="milestone-label"
          className="input"
          value={label}
          maxLength={30}
          placeholder="如：报名截止 / 初赛答辩"
          onChange={(event) => setLabel(event.target.value)}
        />
      </div>
      <div className="field" style={{ maxWidth: '170px' }}>
        <label className="field-label" htmlFor="milestone-due">
          截止时间
        </label>
        <input
          id="milestone-due"
          className="input"
          type="date"
          value={dueAt}
          onChange={(event) => setDueAt(event.target.value)}
        />
      </div>
      <Button variant="primary" type="submit" loading={submitting} disabled={label.trim() === '' || dueAt === ''}>
        添加里程碑
      </Button>
    </form>
  );
}
